import React, { useEffect, useCallback, useState} from "react";
import Meta from "../../components/Meta";

import Hero from "../../components/hero/hero";

const P2P = () => {
  

  useEffect(() => {
    console.log('init')
  }, []);

  return (
    <>
      <Meta title="쿠팡버튼 누르고 사토시 포인트 받기" 
      desc={"비트코인, lightning network, otc 거래, p2p 거래"} keyword={"비트코인, p2p, lightning network, otc"}
      />
	  <Hero></Hero>
    </>
  );
};

export default P2P;

